/**
 * key 和 value 里面的 path 属性保持一致, 都是整体路由
 * value 的一些属性备注
 *     name 显示在头部菜单的内容
 *     title 显示在具体内容的标题, 大部分情况下和 name 相同, 可能存在和 name 不同
 *     hidden 是否隐藏此项, 为 true 表示隐藏, 默认 false 或 undefined
 *     routeType 路由类型, 在工具菜单内属于哪个类型 1: 卡首屏系列 2: 手淘卡屏
 *     invokeName 请求日志需要的参数
 *     priceName 请求工具价格需要的参数
 *     freeForMembers true 表示菜单展示会员免费 默认 false 或 undefined
 * 注意: menus 里面的卡首屏和手淘卡屏区分是通过 routeType, 接口里面卡首屏和手淘卡屏区分是通过 invokeName
 */
const infoData = {
    '/first-flow-dy/first-flow': {
        name: '抖音搜索卡首屏',
        title: '抖音搜索卡首屏',
        path: '/first-flow-dy/first-flow',
        desc: '抖音搜索卡首屏可以帮助到您的流量入口为【抖音商城搜索、商品详情顶部搜索】，目前权重最高的渠道，生成二维码后通过这个入口下单，第二天的商品来源会来自【搜索】',
        hidden: false, // 是否隐藏, 默认 false
        routeType: '1', // 路由类型 1: 卡首屏系列
        freeForMembers: false,
        priceName: "dygjzksp",
        logType: "qrcode", // log 是生成记录, qrcode 是二维码生成记录
        logName: "dygjzksp", // 之前日志是 invokeName, 后期改版, invokeName 专门用来获取 type, 日志由 logType 和 logName 处理
    },
    '/first-flow-dy/guess': {
        name: '抖音猜你喜欢',
        title: '抖音猜你喜欢',
        path: '/first-flow-dy/guess',
        desc: '抖音卡猜你喜欢可以帮助到您的流量入口为【商城推荐流量】，目前是权重较高，生成二维码后通过这个入口下单，第二天的商品来源会来自【商城推荐流量】',
        hidden: false, // 是否隐藏, 默认 false
        routeType: '1', // 路由类型 1: 卡首屏系列
        freeForMembers: false,
        priceName: "dycnxh",
        logType: "qrcode", // log 是生成记录, qrcode 是二维码生成记录
        logName: "dycnxh", // 之前日志是 invokeName, 后期改版, invokeName 专门用来获取 type, 日志由 logType 和 logName 处理
    },
    '/dy-first-page': {
        name: '抖音黑科技卡首屏',
        title: '抖音黑科技卡首屏',
        path: '/dy-first-page',
        routeType: '1', // 路由类型 1: 卡首屏系列
    },
}

export {
    infoData,
}
